import React, { useState } from "react";
import {
  Button,
  Container
} from "reactstrap";

import ScheduleSelector from 'react-schedule-selector'
import OtpInput from '../../components/OtpInput/IndexOtpInput';
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import { otpSend, otpResend, otpVerify, register, checkExit, addEvaluation } from '../../actions'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns'
import { th } from 'date-fns/locale';
// valid
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

const RegisterSchema = Yup.object().shape({
  firstName: Yup.string() //ประเภทของข้อมูลคือ String
    .min(2, 'ชื่อสั้นเกินไป!') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'ชื่อยาวเกินไป!') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรอกนามสกุล'), //ต้องกรอกช่องนี้
  lastName: Yup.string() //ประเภทของข้อมูลคือ String
    .min(2, 'นามสกุลสั้นเกินไป!') //ต้องมีอย่างน้อย 2 ตัวอักษรขึ้นไป
    .max(50, 'นามสกุลยาวเกินไป!') //สูงสุด 50 ตัวอักษร
    .required('ต้องกรอกนามสกุล'), //ต้องกรอกช่องนี้
  password: Yup.string() //ประเภทของข้อมูลคือ String
    .min(6, 'ต้องมีอักษร 6 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องกรอกรหัสผ่าน') //ต้องกรอกช่องนี้
    .matches('^(?=.*[a-z])(?=.*[A-Z]).{6,}$', 'กรุณากรอกอย่างน้อย 6 ตัวอักษร (ภาษาอังกฤษตัวพิมพ์เล็ก ตัวพิมพ์ใหญ่)'),
  confirmPassword: Yup.string() //ประเภทของข้อมูลคือ String
    .min(3, 'ต้องมีอักษร 3 ตัวขึ้นไป') //ต้องมีอย่างน้อย 3 ตัวอักษรขึ้นไป
    .required('ต้องยืนยันรหัสผ่าน') //ต้องกรอกช่องนี้
    //ตรวจสอบว่า password match หรือไม่
    .test('passwords-match', 'รหัสผ่านไม่ตรงกัน', function (value) {
      return this.parent.password === value;
    }),
  mobile: Yup.string()
    .required("ต้องระบุหมายเลขโทรศัพท์")
    .matches(phoneRegExp, 'กรอกข้อมูลไม่ถูกต้อง')
    .min(10, "เบอร์โทรศัพท์เคลื่อนที่ สั้นเกินไป")
    .max(10, "เบอร์โทรศัพท์เคลื่อนที่ ยาวเกินไป")
    .test('mobile-can-use', 'ไม่สามารถใช้หมายเลขนี้ได้', function (value) {
        if(value){
          if(value.length==10)
          return checkExit(value).then(res => {
            if (res.length > 0) {
              return false
            } else {
              return true
            }
          })
        }
        else return false;
    }),
  email: Yup.string() //ประเภทของข้อมูลคือ String
    .required('ต้องกรอกอีเมล'), //ต้องกรอกช่องนี้

});

// core components
function SignUp({
  score,
  onSuccess
}) {

  const [otpCode, setOtpCode] = useState(null)
  const [otpRef, setOtpRef] = useState(null)
  const [otpShow, setOtpShow] = useState(false)
  const [isOtpVerify, setIsOtpVerify] = useState(false)
  const [otpTimeOut, setOtpTimeOut] = useState(null)
  const [otpButtonDisable, setOtpButtonDisable] = useState(false)
  const [otpErrorMessage, setOtpErrorMessage] = useState('')

  const [mobileNo, setMobileNo] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState(new Date());

  
  const [schedule, setSchedule] = useState([])

  const handleChangeSchedule = newSchedule => {
    setSchedule(newSchedule)
  }


  const isNumber = (text) => {
    let value = '';
    let valid = false;
    let numbers = '0123456789';
    for (var i = 0; i < text.length; i++) {
      if (numbers.indexOf(text[i]) > -1) {
        value = value + text[i];
        valid = true
      }
      else {
        valid = false
      }
    }
    return { value, valid }

  }

  const _onOtpSend = () => {
    if (mobileNo.length == 10) {
      otpSend(mobileNo).then((res) => {
        if (res.otp_ref.length > 0) {
          setOtpRef(res.otp_ref)
          setOtpShow(true)
          setOtpTimeOut(60)
          setOtpButtonDisable(true)
          setInterval(() => {
            if (otpTimeOut > 0) {
              setOtpTimeOut(otpTimeOut - 1)
              if (otpTimeOut == 0) {
                setOtpButtonDisable(false)
              }
            } else {
              setOtpTimeOut(null)
            }
          }, 1000)
        } else {
          setOtpRef('')
          setOtpShow(false)
        }
      }).catch((error) => {
        console.log('เครือข่ายขัดข้อง')
      })
    }
  }

  const _onOtpResend = () => {
    setOtpTimeOut(60)
    setOtpButtonDisable(true)
    setInterval(() => {
      if (otpTimeOut > 0) {
        setOtpTimeOut(otpTimeOut - 1)
        if (otpTimeOut == 0) {
          setOtpButtonDisable(false)
        }
      } else {
        setOtpTimeOut(null)
      }
    }, 1000)
    otpResend(mobileNo).then((res) => {
      if (res.mobile_no.length > 0) {
        setOtpRef(res.otp_ref)
        setOtpShow(true)
      } else {
        setOtpShow(false)
        setOtpRef('')
      }
    }).catch((error) => {
      console.log('เครือข่ายขัดข้อง')
    })
  }

  const _onSubmit = (data) => {

    const regModel = {
      firstName: data.firstName,
      lastName: data.lastName,
      ageNumber: data.ageNumber,
      telephoneNumber1: data.mobile,
      username: data.mobile,
      password: data.password,
      confirmPassword: data.confirmPassword,
      dateofbirth: '2023-01-01',
      user_type_service: data.user_type_service,
      issue_type: data.issue_type,
      counselling_detail : data.counselling_detail,
      counselling_type : data.counselling_type,
      counsellor_type : data.counsellor_type,
      counsellor_gender : data.counsellor_gender,
      remark : data.remark,
      email: data.email,
      counselling_schedule: JSON.stringify(schedule)
    }

    register(regModel).then((res) => {
      if (res) {
        var index = res.toString().indexOf("Error:")
        if (index == -1) {
          let token = res.data
          const data = {
            telephoneNo: mobileNo,
            score: score,
            isStress: true,
            isDepression: false
          }
          /*
          addEvaluation(data, token).then(res => {
            onSuccess(true)
          })
          */
          onSuccess(true)
        } else {
          onSuccess(false)
        }
      } else {

      }
    }).catch((error) => {

    })
    /*
    if (otpCode.length == 6) {
      otpVerify(mobileNo, otpCode, otpRef).then((res) => {
        if (res == true) {
          setIsOtpVerify(true)
          setOtpButtonDisable(true)
          const regModel = {
            firstName: data.firstName,
            lastName: data.lastName,
            telephoneNumber1: data.mobile,
            username: data.mobile,
            password: data.password,
            confirmPassword: data.confirmPassword,
          }

          register(regModel).then((res) => {
            if (res) {
              var index = res.toString().indexOf("Error:")
              if (index == -1) {
                let token = res.data
                const data = {
                  telephoneNo: mobileNo,
                  score: score,
                  isStress: true,
                  isDepression: false
                }
                addEvaluation(data, token).then(res => {
                  onSuccess(true)
                })
              } else {
                onSuccess(false)
              }
            } else {

            }
          }).catch((error) => {

          })
        } else {
          setOtpErrorMessage('รหัส OTP ไม่ถูกต้อง')
          setIsOtpVerify(false)
        }
      }).catch((error) => {
        setIsOtpVerify(false)
      })
    } else {
      setOtpErrorMessage('รหัส OTP ไม่ถูกต้อง')
    }
    */
  }

  return (
    <Container>
      <div>
        <Formik
          initialValues={{
            firstName: '',
            lastName: '',
            dateofbirth: '',
            ageNumber: '',
            user_type_service: 0,
            issue_type: 10,
            counselling_detail : '',
            counselling_type : 1,
            counsellor_type : 0,
            counsellor_gender : 0,
            remark : '',
            password: '',
            confirmPassword: '',
            mobile: '',
            email: ''
          }}
          validationSchema={RegisterSchema}
          onSubmit={(e) => _onSubmit(e)}
        >
          {({ errors, touched, handleSubmit, handleReset, setFieldValue }) => (
            <Form onSubmit={handleSubmit} onReset={handleReset}>
              <div className="form-group">
                <label htmlFor="firstName" >
                  ชื่อ
                             </label>
                <Field
                  name="firstName"
                  type="text"
                  className={`form-control ${touched.firstName ? errors.firstName ? 'is-invalid' : 'is-valid' : ''}`}
                  id="firstName"
                  placeholder="Enter First name"
                />
                <ErrorMessage component="div" name="firstName" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="lastName" >
                  นามสกุล
                             </label>
                <Field
                  name="lastName"
                  type="text"
                  className={`form-control ${touched.lastName ? errors.lastName ? 'is-invalid' : 'is-valid' : ''}`}
                  id="lastName"
                  placeholder="Enter Last Name"
                />
                <ErrorMessage component="div" name="lastName" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="ageNumber" >
                  อายุ
                             </label>
                <Field
                  name="ageNumber"
                  type="number"
                  className={`form-control ${touched.ageNumber ? errors.ageNumber ? 'is-invalid' : 'is-valid' : ''}`}
                  id="ageNumber"
                  placeholder="Enter age (years)"
                />
                <ErrorMessage component="div" name="ageNumber" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="user_type_service" >
                 ประเภทของผู้รับบริการ
                             </label><br />
                <Field component="div" className="form-control" name="user_type_service_compoment">
                  <input  type="radio" id="user_type_service1" defaultChecked={true} name="user_type_service" value="1" />
                  <label htmlFor="user_type_service1">นิสิตคณะศึกษาศาสตร์</label> <br />

                  <input  type="radio" id="user_type_service2" defaultChecked={false} name="user_type_service" value="2" />
                  <label htmlFor="user_type_service2">นิสิตมหาวิทยาลัยมหาสารคาม</label> <br />

                  <input  type="radio" id="user_type_service3" defaultChecked={false} name="user_type_service" value="3" />
                  <label htmlFor="user_type_service3">บุคลากรมหาวิทยาลัยมหาสารคาม</label> <br />

                  <input  type="radio" id="user_type_service4" defaultChecked={false} name="user_type_service" value="4" />
                  <label htmlFor="user_type_service4">บุคคลทั่วไป</label> <br />

                  <input  type="radio" id="user_type_service5" defaultChecked={false} name="user_type_service" value="5" />
                  <label htmlFor="user_type_service5">อื่นๆ</label> <br />

                </Field>
                <ErrorMessage component="div" name="user_type_service" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label htmlFor="issue_type" >
                 ประเด็นปรึกษา
                             </label><br />
                <Field component="div" className="form-control" name="issue_type_compoment">
                  <input  type="radio" id="issue_type1" defaultChecked={true} name="issue_type" value="1" />
                  <label htmlFor="issue_type1">เครียด/วิตกกังวล</label> <br />

                  <input  type="radio" id="issue_type2" defaultChecked={false} name="issue_type" value="2" />
                  <label htmlFor="issue_type2">การเรียน</label> <br />

                  <input  type="radio" id="issue_type3" defaultChecked={false} name="issue_type" value="3" />
                  <label htmlFor="issue_type3">ซึมเศร้า/อาการทางจิตเวช</label> <br />

                  <input  type="radio" id="issue_type4" defaultChecked={false} name="issue_type" value="4" />
                  <label htmlFor="issue_type4">เพื่อน</label> <br />

                  <input  type="radio" id="issue_type5" defaultChecked={false} name="issue_type" value="5" />
                  <label htmlFor="issue_type5">ความรัก</label> <br />

                  <input  type="radio" id="issue_type6" defaultChecked={false} name="issue_type" value="6" />
                  <label htmlFor="issue_type6">การทำงาน</label> <br />

                  <input  type="radio" id="issue_type7" defaultChecked={false} name="issue_type" value="7" />
                  <label htmlFor="issue_type7">การปรับตัว</label> <br />

                  <input  type="radio" id="issue_type8" defaultChecked={false} name="issue_type" value="8" />
                  <label htmlFor="issue_type8">ครอบครัว</label> <br />

                  <input  type="radio" id="issue_type9" defaultChecked={false} name="issue_type" value="9" />
                  <label htmlFor="issue_type9">คลินิก LD</label> <br />

                  <input  type="radio" id="issue_type10" defaultChecked={false} name="issue_type" value="10" />
                  <label htmlFor="issue_type10">อื่นๆ</label> <br />

                </Field>
                <ErrorMessage component="div" name="issue_type" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label htmlFor="counselling_detail" >
                  รายละเอียดประเด็นการปรึกษา
                             </label>
                <Field
                  name="counselling_detail"
                  type="textarea"
                  className="form-control"
                  id="counselling_detail"
                  placeholder="รายละเอียดเกี่ยวกับประเด็นการปรึกษาคร่าวๆ เท่าที่ท่านสามารถระบุได้"
                />
                <ErrorMessage component="div" name="counselling_detail" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label>
                เวลาที่คุณสะดวก (เลือกมากกว่า 1 เวลา เพื่อความสะดวกในการบริหารเวลานัดหมาย)
  โปรดเลือกวันและช่วงเวลาที่สะดวก
                </label>
                
                  <ScheduleSelector
                    selection={schedule}
                    startDate="2023-01-02"
                    numDays={5}
                    minTime={9}
                    maxTime={16}
                    hourlyChunks={1}
                    onChange={(item) => handleChangeSchedule(item)}
                    renderDateLabel={(date) =>{
                      return <span>
                          {format(date,'d')==2 && 'จันทร์'}
                          {format(date,'d')==3 && 'อังคาร'}
                          {format(date,'d')==4 && 'พุธ'}
                          {format(date,'d')==5 && 'พฤหัส'}
                          {format(date,'d')==6 && 'ศุกร์'}
                        </span>}
                    }
                  />
              </div>

              <div className="form-group">
                <label htmlFor="counselling_type" >
                 ต้องการรับบริการแบบใด
                             </label><br />
                <Field component="div" className="form-control" name="counselling_type_compoment">
                  <input  type="radio" id="counselling_type1" defaultChecked={true} name="counselling_type" value="1" />
                  <label htmlFor="counselling_type1">การให้การปรึกษาแบบพบหน้า</label> <br />

                  <input  type="radio" id="counselling_type2" defaultChecked={false} name="counselling_type" value="2" />
                  <label htmlFor="counselling_type2">การให้การปรึกษาแบบออนไลน์</label> <br />

                </Field>
                <ErrorMessage component="div" name="counselling_type" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label htmlFor="counsellor_type" >
                 ต้องการพบผู้ให้การปรึกษาที่เป็น
                             </label><br />
                <Field component="div" className="form-control" name="counsellor_type_compoment">
                  <input  type="radio" id="counsellor_type1" defaultChecked={true} name="counsellor_type" value="1" />
                  <label htmlFor="counsellor_type1">อาจารย์</label> <br />

                  <input  type="radio" id="counsellor_type2" defaultChecked={false} name="counsellor_type" value="2" />
                  <label htmlFor="counsellor_type2">นิสิตจิตวิทยา การปรึกษาแบบเพื่อนช่วยเพื่อน พี่ช่วยน้อง</label> <br />

                  <input  type="radio" id="counsellor_type3" defaultChecked={false} name="counsellor_type" value="0" />
                  <label htmlFor="counsellor_type3">ไม่ระบุ</label> <br />
                </Field>
                <ErrorMessage component="div" name="counsellor_type" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label htmlFor="counsellor_gender" >
                 ต้องการพบผู้ให้การปรึกษาเพศ
                             </label><br />
                <Field component="div" className="form-control" name="counsellor_gender_compoment">
                  <input  type="radio" id="counsellor_gender1" defaultChecked={true} name="counsellor_gender" value="1" />
                  <label htmlFor="counsellor_gender1">ชาย</label> <br />

                  <input  type="radio" id="counsellor_gender2" defaultChecked={false} name="counsellor_gender" value="2" />
                  <label htmlFor="counsellor_gender2">หญิง</label> <br />

                  <input  type="radio" id="counsellor_gender3" defaultChecked={false} name="counsellor_gender" value="0" />
                  <label htmlFor="counsellor_gender3">ไม่ระบุ</label> <br />
                </Field>
                <ErrorMessage component="div" name="counsellor_gender1" className="invalid-feedback" />
              </div>


              <div className="form-group">
                <label htmlFor="password" >
                  รหัสผ่าน
                              </label>
                <Field
                  name="password"
                  type="password"
                  className={`form-control ${touched.password ? errors.password ? 'is-invalid' : 'is-valid' : ''}`}
                  id="password"
                  placeholder="Password"
                />
                <ErrorMessage component="div" name="password" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword" >
                  ยืนยันรหัสผ่าน
                              </label>
                <Field
                  name="confirmPassword"
                  type="password"
                  className={`form-control ${touched.confirmPassword ? errors.confirmPassword ? 'is-invalid' : 'is-valid' : ''}`}
                  id="confirmPassword"
                  placeholder="Enter Confirm Password"
                />
                <ErrorMessage component="div" name="confirmPassword" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="email" >
                  อีเมล​
                             </label>
                <Field
                  name="email"
                  type="email"
                  className={`form-control ${touched.email ? errors.email ? 'is-invalid' : 'is-valid' : ''}`}
                  id="email"
                  placeholder="Enter email"
                />
                <ErrorMessage component="div" name="email" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label htmlFor="lastName" >
                  เบอร์โทรศัพท์มือถือ (Username เข้าใช้ระบบ)
                             </label>
                <Field
                  name="mobile"
                  type="text"
                  className={`form-control ${touched.mobile ? errors.mobile ? 'is-invalid' : 'is-valid' : ''}`}
                  id="mobile"
                  onChange={e => {

                    e.preventDefault();
                    const { value } = e.target;
                    if (value.length < 11) {
                      const mobileNo = isNumber(value)
                      setFieldValue("mobile", mobileNo.value);
                      setMobileNo(mobileNo.value)
                    }
                  }}
                  placeholder="Enter Mobile Phone No"
                />
                <ErrorMessage component="div" name="mobile" className="invalid-feedback" />
              </div>

              <div className="form-group">
                <label htmlFor="remark" >
                  ข้อคิดเห็น ข้อมูลเพิ่มเติม ข้อสงสัย
                             </label>
                <Field
                  name="remark"
                  type="textarea"
                  className="form-control"
                  id="remark"
                  placeholder=" ข้อคิดเห็น ข้อมูลเพิ่มเติม ข้อสงสัย (ถ้ามี)"
                />
                <ErrorMessage component="div" name="remark" className="invalid-feedback" />
              </div>
              <div className="form-group">
                <label  >
                   
                    หมายเหตุ ผู้ให้การปรึกษาจะติดต่อกลับทางอีเมล์ภายใน 24-72 ชั่วโมงของวันทำการ 
                    และหากผู้รับริการไม่แสดงตนเข้ารับบริการตามวันเวลานัดหมาย ภายใน 15 นาที จะขอสงวนสิทธิ์ในการยกเลิกบริการครั้งนั้น  <br /> <br />
                    
                     
                  </label>

                  
                  <label htmlFor="checked">ข้าพเจ้ารับรองว่าการให้ข้อมูลทั้งหมดนี้เป็นความจริงและประสงค์เข้ารับบริการตามเงื่อนไขที่กำหนด</label> <br />
                 
              </div>

              {/*<div className="text-center">
                {mobileNo.length == 10 && !errors.mobile &&
                  <Button
                    className="btn-default btn-round"
                    color="default"
                    onClick={() => _onOtpSend()}
                    style={{ margin: 0 }}
                  >
                    ขอรหัส OTP
                </Button>}
                <br />

                {otpRef &&
                  <>
                    <span>รหัสอ้างอิง : {otpRef}</span>
                    <br />
                    <OtpInput
                      onChange={(e) => setOtpCode(e)}
                      value={otpCode}
                      numberOnly={true}
                    />
                  </>
                }
              </div> */}

              
              <div className="row">
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="submit" className="btn-round" color="info" style={{ width: '80%' }}>สมัครเข้ารับบริการ</Button>
                </div>
                <div className="col-md-6" style={{ textAlign: 'center' }}>
                  <Button type="reset" className="btn-round" color="primary" style={{ width: '50%' }}>ล้างค่า</Button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Container>
  );
}

export default SignUp;
